/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import logo from "assets/images/profile_icon.png";
import { useIntl } from "react-intl";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import Footer from "examples/Footer";
import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useCategorias } from "hooks/useCategorias";
import CategoriaModulo from "components/VistaModulos/CategoriaModulo";
import { FormikProvider } from "formik";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { Spinner } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";

function Categorias(): JSX.Element {
  const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || false);

  const {
    intl,
    formik,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    categorias,
    //crear categoria
    isAlertOpenCrearCategoria,
    handleisAlertCrearCategoriaOpen,
    handleisAlertCrearCategoriaClose,
    getFieldColor,
    procesandoCategoria,
    createCategoria,
    desactivarCategoria,
    activarCategoria,
    editarCategoria,
    verEditarCategoria,
    isAlertOpenEditarCategoria,
    handleisAlertOpenEditarCategoria,
    handleisAlertCloseEditarCategoria,
    setVerEditarCategoria,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    buscador,
    handleBuscadorChange,
    categoriasPaginadas,
  } = useCategorias();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Typography variant="h4" gutterBottom>
                Categorías
              </Typography>
            </Grid>
            <Grid>
              <CategoriaModulo
                verCategorias={categorias}
                desactivarCategoria={desactivarCategoria}
                activarCategoria={activarCategoria}
                handleisAlertCrearCategoriaOpen={handleisAlertCrearCategoriaOpen}
                handleisAlertOpenEditarCategoria={handleisAlertOpenEditarCategoria}
                setVerEditarCategoria={setVerEditarCategoria}
                categoriasPaginadas={categoriasPaginadas}
                page={page}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                buscador={buscador}
                handleBuscadorChange={handleBuscadorChange}
              />
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
      {/* MODAL PARA AÑADIR CATEGORÍA */}
      <ModalComponent
        handleClose={handleisAlertCrearCategoriaClose}
        isOpen={isAlertOpenCrearCategoria}
        key={"alerta-crear-categoria"}
      >
        <FormikProvider value={formik!}>
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} md={12} mt={2}>
              <Typography variant="h5" color="primary" gutterBottom sx={{ color: "#004c93", textAlign: "center" }}>
                Registrar categoría
              </Typography>
            </Grid>
            <br />
            <Grid item xs={6} sm={6}>
              <TextField
                id="clave"
                fullWidth
                label={`${intl.formatMessage({ id: "input_clave" })}`}
                variant="standard"
                name="clave"
                value={formik.values.clave || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("clave", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.clave && Boolean(formik.errors.clave)}
                helperText={formik.touched.clave && formik.errors.clave}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("clave"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("clave"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("clave"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("clave"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="nombre"
                fullWidth
                label={`${intl.formatMessage({ id: "input_nombre" })}`}
                variant="standard"
                name="nombre"
                value={formik.values.nombre || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("nombre", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                helperText={formik.touched.nombre && formik.errors.nombre}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("nombre"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("nombre"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("nombre"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("nombre"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="descripcion"
                fullWidth
                label={`${intl.formatMessage({ id: "input_descripcion" })}`}
                variant="standard"
                name="descripcion"
                value={formik.values.descripcion || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("descripcion", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.descripcion && Boolean(formik.errors.descripcion)}
                helperText={formik.touched.descripcion && formik.errors.descripcion}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("descripcion"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("descripcion"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("descripcion"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("descripcion"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                sx={{ color: "#fff", background: "#084d6e" }}
                variant="contained"
                endIcon={<AddBoxIcon />}
                disabled={procesandoCategoria}
                onClick={(e: any) => {
                  const datos = {
                    clave: formik.values.clave,
                    nombre: formik.values.nombre,
                    descripcion: formik.values.descripcion,
                    id_usuario: idUsuario,
                  };
                  createCategoria(datos);
                }}
              >
                {procesandoCategoria ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {intl.formatMessage({ id: "general_añadiendo" })}...{" "}
                  </>
                ) : (
                  intl.formatMessage({ id: "general_añadir" })
                )}
              </Button>
            </Grid>
          </Grid>
        </FormikProvider>
      </ModalComponent>
      {/* MODAL PARA EDITAR LA CATEGORÍA */}
      <ModalComponent
        handleClose={handleisAlertCloseEditarCategoria}
        isOpen={isAlertOpenEditarCategoria}
        key={"alertaEditarCategoria"}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          {verEditarCategoria && (
            <>
              <Grid item xs={12} mt={2}>
                <h5>Editando categoría</h5>
              </Grid>
              <Grid item xs={6} sm={4} sx={{ position: "relative" }}>
                <TextField
                  id="editaClave"
                  fullWidth
                  label={intl.formatMessage({ id: "input_clave" })}
                  variant="standard"
                  name="editaClave"
                  value={formik.values.clave || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue("clave", value);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={4} sx={{ position: "relative" }}>
                <TextField
                  id="editaNombre"
                  fullWidth
                  label={intl.formatMessage({ id: "input_nombre" })}
                  variant="standard"
                  name="editaNombre"
                  value={formik.values.nombre || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue("nombre", value);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={4} sx={{ position: "relative" }}>
                <TextField
                  id="editaDescripcion"
                  fullWidth
                  label={intl.formatMessage({ id: "input_descripcion" })}
                  variant="standard"
                  name="editaDescripcion"
                  value={formik.values.descripcion || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue("descripcion", value);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Button
                  sx={{ color: "#fff", background: "#084d6e" }}
                  variant="contained"
                  endIcon={<EditIcon />}
                  disabled={procesando}
                  onClick={(e: any) => {
                    const datos = {
                      id_categoria: verEditarCategoria?.id,
                      clave: formik.values.clave,
                      nombre: formik.values.nombre,
                      descripcion: formik.values.descripcion,
                    };
                    editarCategoria(datos);
                  }}
                >
                  {procesandoCategoria ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      {intl.formatMessage({ id: "general_editando" })}...{" "}
                    </>
                  ) : (
                    intl.formatMessage({ id: "general_editar" })
                  )}
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default Categorias;
